import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import cn from "classnames"
import Heading from "../Widgets/Heading"
import RichTextContainer from "../Widgets/RichTextContainer"
import theme from "../../styles/theme"

class FaqItem extends PureComponent {
    state = {
        open: false,
    }

    toggleOpen = () => {
        this.setState(({open}) => ({open: !open}))
    }

    render() {
        const {classes, item: {question, answer}, questionTag, idPrefix} = this.props;
        const {open} = this.state;
        const buttonId = `${idPrefix}-question`;
        const answerId = `${idPrefix}-answer`;

        return (
            <div className={classes.item}>
                <Heading tag={questionTag} className={classes.question}>
                    <button
                        type="button"
                        id={buttonId}
                        className={classes.button}
                        aria-expanded={open}
                        aria-controls={answerId}
                        onClick={this.toggleOpen}
                    >
                        <span>{question}</span>
                        <svg className={cn(classes.icon, {[classes.iconOpen]: open})} viewBox="0 0 8 8" aria-hidden="true" focusable="false">
                            <path fill="currentColor" d="M4 6.67l-4-4 .998.001L3.997 5.631l3-3L8 2.67l-4 4Z" />
                        </svg>
                    </button>
                </Heading>
                <div
                    id={answerId}
                    role="region"
                    aria-labelledby={buttonId}
                    className={cn(classes.answer, {[classes.answerOpen]: open})}
                >
                    <div className={classes.answerInner}>
                        <RichTextContainer className={classes.answerText} content={answer} removeBottomMargin={true} />
                    </div>
                </div>
            </div>
        )
    }
}

export default injectSheet({
    item: {
        borderBottom: `1px solid ${theme.colors.faintGrey}`,
        padding: [theme.spacing.small, 0],
    },
    question: {
        margin: 0,
        fontFamily: theme.font.family,
        fontSize: theme.getRemValue(16),
        fontWeight: 700,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textTransform: 'none',
    },
    button: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        padding: 0,
        border: 0,
        background: 'none',
        color: 'inherit',
        font: 'inherit',
        textAlign: 'left',
        cursor: 'pointer',
        '& > span': {
            flex: '1 1 auto',
            paddingRight: theme.spacing.small,
        },
    },
    icon: {
        flex: '0 0 auto',
        width: 16,
        height: 16,
        transition: 'transform 0.15s ease-in-out',
    },
    iconOpen: {
        transform: 'rotate(180deg)',
    },
    answer: {
        display: 'grid',
        gridTemplateRows: '0fr',
        overflow: 'hidden',
        visibility: 'hidden',
        transition: 'grid-template-rows 0.3s ease-in-out, visibility 0.3s',
    },
    answerOpen: {
        gridTemplateRows: '1fr',
        visibility: 'visible',
    },
    answerInner: {
        minHeight: 0,
    },
    answerText: {
        paddingTop: theme.spacing.small,
    },
})(FaqItem)



// WEBPACK FOOTER //
// ./src/components/Article/FaqItem.js